import { render } from "./ModTitleComp.vue?vue&type=template&id=3a19758b&scoped=true&ts=true"
import script from "./ModTitleComp.vue?vue&type=script&lang=ts"
export * from "./ModTitleComp.vue?vue&type=script&lang=ts"

import "./ModTitleComp.vue?vue&type=style&index=0&id=3a19758b&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a19758b"]])

export default __exports__